import { Box, Flex } from "@chakra-ui/react"
import { Heading, Text } from "@chakra-ui/layout"
import * as React from "react"
import { MojoList } from "../list"
import { Login } from "./Login"
import { Signup } from "./Signup"
import { ForgotPassword } from "./ForgotPassword"
import { ChoosePlan } from "../section"
import { usePurchasingCTAs } from "./usePurchasingCTAs"

export function EntryForm({
  header,
  subheader,
  title,
  bulletPoints,
  paragraphs,
  imageArray,
  pageType,
  youtubeId,
}) {
  const { titleBg, titleColor } = usePurchasingCTAs()
  return (
    <Box padding={{ base: `100px 0 10px`, md: "160px 0 80px" }}>
      <Box maxW="980px" m="0 auto">
        <Flex
          flexWrap={{ base: `wrap`, md: `nowrap` }}
          justifyContent="space-around"
          flexDirection={{
            base: pageType === "products" ? `row` : `column-reverse`,
            md: `row`,
          }}
        >
          {pageType === "products" && (
            <Box
              flex="1 0 0px"
              p={{ base: `0 20px`, md: 0 }}
              pb="30px"
              mb={{ base: `30px`, md: 0 }}
            >
              <ChoosePlan header={header} subheader={subheader} />
            </Box>
          )}

          <Box
            flex={{ base: `0 0 100%`, md: "1 0 0px" }}
            p={{ base: `0 20px`, md: 0 }}
          >
            {header && (
              <Box
                display={{
                  base: `none`,
                  lg: `block`,
                }}
              >
                <Heading
                  textTransform="uppercase"
                  textAlign={{
                    base: pageType === `products` ? `left` : `center`,
                    lg: "left",
                  }}
                  fontSize={{ base: `28px`, md: "30px" }}
                  lineHeight="32px"
                  fontWeight="600"
                  mb={{ base: `0`, lg: `23px` }}
                >
                  <Box as="span" bg={titleBg} color={titleColor}>
                    {header}
                  </Box>
                </Heading>
                {subheader && (
                  <Box alignSelf="center" mb="30px">
                    <Text
                      color="black"
                      fontSize="16px"
                      lineHeight="24px"
                      dangerouslySetInnerHTML={{ __html: subheader }}
                    />
                  </Box>
                )}
              </Box>
            )}
            <MojoList
              pageType={pageType}
              title={title}
              paragraphs={paragraphs}
              bulletPoints={bulletPoints}
              imageArray={imageArray}
              youtubeId={youtubeId}
            />
          </Box>
          {pageType !== "products" && (
            <Box
              flex={{ base: `0 0 100%`, md: "1 0 0px" }}
              p={{ base: `0 20px`, md: 0 }}
              mb={{ base: `60px`, md: 0 }}
            >
              <Box display={{ base: `block`, md: `none` }}>
                {pageType !== "login" && (
                  <Heading
                    textTransform="uppercase"
                    textAlign={{ base: `center`, lg: "left" }}
                    fontSize="28px"
                    lineHeight="34px"
                    fontWeight="600"
                    mb={{ base: `22px`, lg: "22px" }}
                  >
                    <Box as="span" bg={titleBg} color={titleColor}>
                      {title}
                    </Box>
                  </Heading>
                )}

                {/* <Box mb="23px">
                  {paragraphs?.map(({ item }) => {
                    return (
                      <Box alignSelf="center" mb="30px">
                        <Text
                          textAlign={{ base: `center`, md: `left` }}
                          fontSize="18px"
                          lineHeight="28px"
                          color="black"
                          dangerouslySetInnerHTML={{ __html: item }}
                        />
                      </Box>
                    )
                  })}
                </Box> */}
              </Box>

              {pageType === "login" && <Login />}
              {pageType === "signup" && <Signup />}
              {pageType === "forgot" && <ForgotPassword />}
            </Box>
          )}
        </Flex>
      </Box>
    </Box>
  )
}
